import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { YourGPT } from '@yourgpt/widget-web-sdk';

import { getId, getEmail, getFirstName } from 'features/User/selectors';

export const useHandleSupport = () => {
  const userId = useSelector(getId);
  const userEmail = useSelector(getEmail);
  const userName = useSelector(getFirstName);

  const handleSupport = useCallback(() => {
    try {
      const sdk = YourGPT.getInstance();

      const contactData = {
        email: userEmail || undefined,
        name: userName || undefined,
        ext_user_id: userId ? String(userId) : undefined,
      };

      sdk.setContactData(contactData);
      sdk.open();
    } catch (error) {
      console.error('[YourGPT Hook] Failed to open widget:', error);
    }
  }, [userId, userEmail, userName]);

  return handleSupport;
};
